/* eslint-disable prettier/prettier */
import { computed } from "vue"
import { useStore } from "vuex"

const filiation = () =>{
    const store = useStore()
    const nameCourts = async()=> {
        const resp =await store.dispatch("filiation/loadNameCourts")
            return resp
    }
    const typeCourts = async()=> {
        const resp =await store.dispatch("filiation/loadTypeCourts")
            return resp
    }
    const typeCodes = async()=> {
        const resp =await store.dispatch("filiation/loadTypeCodes")
            return resp
    }
    const typeOrders = async()=> {
        const resp =await store.dispatch("filiation/loadTypeOrders")
            return resp
    }
    const prisionNames = async()=> {
        const resp =await store.dispatch("filiation/loadPrisionNames")
            return resp
    }
    const crimes = async()=> {
        const resp =await store.dispatch("filiation/loadCrimes")
            return resp
    }
    const documentType = async()=> {
        const resp =await store.dispatch("filiation/loadDocumentTypes")
            return resp
    }
    const nameDepartaments = async () =>{
        const resp =await store.dispatch("filiation/loadDepartaments")
            return resp
    }
    const nameProvinces = async (data) =>{
        const resp =await store.dispatch("filiation/loadProvinces",data)
            return resp
    }
    const nameMunicipalities = async (data) =>{
        const resp =await store.dispatch("filiation/loadMunicipalities",data)
           return resp
    }
    const checkData = async (data) =>{
        const resp =await store.dispatch("filiation/checkData", data)
          return resp
    }
    const civilStatus = async () =>{
        const resp =await store.dispatch("filiation/loadCivilStatus")
           return resp
    }
    const ethnicIdentification = async () =>{
        const resp =await store.dispatch("filiation/loadEthnicIdentification")
           return resp
    }
    const languages = async () =>{
        const resp =await store.dispatch("filiation/loadLanguages")
           return resp
    }
    const sexual_orientation = async () =>{
        const resp =await store.dispatch("filiation/loadSexualOrientation")
           return resp
    }
    const religions = async () =>{
        const resp =await store.dispatch("filiation/loadReligion")
           return resp
    }
    const professions = async () =>{
        const resp =await store.dispatch("filiation/loadProfession")
           return resp
    }
    const jobs = async () =>{
        const resp =await store.dispatch("filiation/loadJob")
           return resp
    }
    const degreeInstructions = async () =>{
        const resp =await store.dispatch("filiation/loadDegreeInstruction")
           return resp
    }
    const relationships = async () =>{
        const resp =await store.dispatch("filiation/loadRelationship")
           return resp
    }
    const sendForm = async (data) => {
                const resp =await store.dispatch("filiation/sendRegistrationForm",data)
                return resp
    }
    const kardex = async (data)=> {
        const resp = await store.dispatch("filiation/printKardex", data)
        return resp
    }
    const PrivateLibertyList = async(data)=>{
                const resp = await store.dispatch("filiation/loadPrivateLibertyList",data)
                return resp
    }
    const countPersonsCenters = async()=>{
                const resp = await store.dispatch("filiation/loadCountPersonsCenter")
                return resp
    }
    const countGenrePersonsCenters = async()=>{
        const resp = await store.dispatch("filiation/loadCountGenrePersonsCenter")
        return resp
    }
    const countPersonsLegalStatus = async()=>{
        const resp = await store.dispatch("filiation/loadCountPersonsLegalStatus")
        return resp
    }
    const countPersonsByDepartment = async()=>{
        const resp = await store.dispatch("filiation/loadCountPersonsByDepartment")
        return resp
    }
    const uploadFile = async(data)=>{
        const resp = await store.dispatch("filiation/uploadFile", data)
        return resp
    }
    const uploadFingerFile = async(data)=>{
        const resp = await store.dispatch("filiation/uploadfingerFile", data)
        return resp
    }
    const resolution = async (data)=> {
        const resp = await store.dispatch("filiation/printResolution", data)
        return resp
    }
    const viewFingers = async (data)=> {
        const resp = await store.dispatch("filiation/viewFingerPrints", data)
        return resp
    }
    const deleteFile = async(data)=>{
        const resp = await store.dispatch("filiation/deleteFile", data)
        return resp
    }
    const deleteFingerPrint = async(data)=>{
        const resp = await store.dispatch("filiation/deleteFingerPrint", data)
        return resp
    }
    const chartData = async(data)=>{
                const resp = await store.dispatch("filiation/chartData",data)
                return resp
    }
    const passData = async(data)=>{
                const resp = await store.dispatch("filiation/passData",data)
                return resp
    }
    const fotosPorId = async(data)=>{
        const resp = await store.dispatch("filiation/fotosPorId",data)
        return resp
}
    const sendEdition = async(data)=>{
        const resp = await store.dispatch("filiation/sendEdition",data)
        return resp
}
    const resetStatus = async()=>{
        const resp = await store.dispatch("filiation/resetStatusEdit")
        return resp
}
    const personalData = async(data)=>{
    const resp = await store.dispatch("filiation/personalData",data)
    return resp
}
    const posibleOrder = async(data)=>{
    const resp = await store.dispatch("filiation/posibleOrder",data)
    return resp
}
    const checkDataAlreadyExist = async(data)=>{
    const resp = await store.dispatch("filiation/checkDataAlreadyExist",data)
    return resp
}
const registerReentry = async(data)=>{
    const resp = await store.dispatch("filiation/registerReentry",data)
    return resp
}
const uploadFingerPrints = async(data)=>{
    const resp = await store.dispatch("filiation/uploadFingerPrints",data)
    return resp
}
const countCrimeByRelationship = async(value) =>{
    const resp = await store.dispatch("filiation/countCrimeByRelationship", value)
    return resp
}
    return{
        nameCourts,
        typeCourts,
        typeCodes,
        typeOrders,
        prisionNames,
        crimes,
        documentType,
        nameDepartaments,
        nameProvinces,
        nameMunicipalities,
        checkData,
        civilStatus,
        ethnicIdentification,
        languages,
        sexual_orientation,
        religions,
        professions,
        jobs,
        degreeInstructions,
        relationships,
        sendForm,
        kardex,
        PrivateLibertyList,
        countPersonsCenters,
        countGenrePersonsCenters,
        countPersonsLegalStatus,
        countPersonsByDepartment,
        uploadFile,
        uploadFingerFile,
        resolution,
        viewFingers,
        deleteFile,
        deleteFingerPrint,
        chartData,
        passData,
        fotosPorId,
        sendEdition,
        resetStatus,
        personalData,
        checkDataAlreadyExist,
        posibleOrder,
        registerReentry,
        uploadFingerPrints,
        countCrimeByRelationship,
        listPpl: computed(()=>store.getters["filiation/listPpl"]),
        chartDataValues: computed(()=>store.getters["filiation/chartDataValues"]),
        chartDataTwoParams: computed(()=>store.getters["filiation/chartDataTwoParams"]),
        chartStatus: computed(()=>store.getters["filiation/chartStatus"]),
        dataToEdit: computed(()=>store.getters["filiation/dataToEdit"]),
        getPersonalData:computed(()=>store.getters["filiation/personalData"]),
        getDataChecked:computed(()=>store.getters["filiation/dataChecked"]),
        getPosibleOrder:computed(()=>store.getters["filiation/posibleOrder"]),
    }
};

export default filiation